import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import DemandList from '../components/table.vue';
import { ratingList } from '@/common/demand';
import { assignmentDemand, revocationDesigner, rejectDemand } from '@/api/demand/demand';
import { assignTaskToDeveloper } from '@/api/demand/interactive';

var validateWorkHours = function validateWorkHours(rule, value, callback) {
  // 正的，小数部分以5结尾的浮点数  或  正整数
  var reg = /^\d*(\.(5|0))?$/;

  if (!reg.test(value) || Number(value) <= 0) {
    callback(new Error('工时消耗（h）只允许输入0.5的整数倍'));
  } else {
    callback();
  }
};

var validateWorkDays = function validateWorkDays(rule, value, callback) {
  if (/[^\d]+/.test(value) || Number(value) <= 0) {
    callback(new Error('只能输入正整数'));
  } else {
    callback();
  }
};

export default {
  components: {
    DemandList: DemandList
  },
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    batchList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    getDemandList: {
      type: Function,
      default: function _default() {}
    },
    dialogConfig: {
      type: Object,
      default: function _default() {}
    },
    cancleBatchDemand: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      /**
       * 1.custom 自定义
       * 2.someday 统一延期
       * 3.sameday 统一改期某天
       */
      formValue: {
        id: '',
        difficulty: '', // 需求评级
        planner_id: '', // 策划师
        designer_id: '', // 设计师
        estimated_time: '', // 计划完成日期
        work_days: '', // 公时消耗（只提供天数选项）
        reject_reason: '', // 驳回原因
        developer_id: '', // 研发师
        skip_plan: '',
        no_dev: '' // 是否需要研发
      },
      formItemList: [],
      formConfig: {
        inline: false,
        labelPosition: 'right',
        labelWidth: '130px'
      },
      loading: false,
      columnConfig: ['cancle-cell', 'id', 'name', 'instruction', 'action-cell', 'type', 'expect_time']
    };
  },


  computed: {
    submitButton: function submitButton() {
      return {
        type: 'primary',
        loading: this.loading
      };
    }
  },

  watch: {
    'dialogConfig.visible': function dialogConfigVisible(val) {
      if (!val) {
        this.resetBatchDialog();
      } else {
        this.formItemList = this.cookFormItemList(this.dialogConfig.batchDialogType);
      }
    },
    batchList: function batchList(val) {
      if (val.length === 0) {
        // eslint-disable-next-line vue/no-mutating-props
        this.dialogConfig.visible = false;
      }
    }
  },

  methods: {
    resetBatchDialog: function resetBatchDialog() {
      this.$refs.form.resetFields();
    },
    cancleDemand: function cancleDemand(_ref) {
      var row = _ref.row;

      this.cancleBatchDemand(row);
    },
    handleChange: function handleChange(val, prop) {
      this.formValue = val.formValue;
    },
    handleValidate: function handleValidate(prop) {},
    handleConfirm: function handleConfirm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var arr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                arr = [];

                _this.batchList.forEach(function (item) {
                  arr.push(_.pick(item, 'id')['id']);
                });
                _this.formValue['id'] = arr.join(',');

                _this.$refs.form.validate(function (valid) {
                  if (valid) _this.submit();
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cookFormItemList: function cookFormItemList(index) {
      var _this2 = this;

      var formItemList = [{
        label: '需求评级',
        prop: 'difficulty',
        type: 'select',
        rules: [{
          required: true,
          message: '请选择需求评级',
          trigger: 'change'
        }],
        params: {
          options: ratingList,
          clearable: true
        }
      }, {
        label: '指定策划师',
        prop: 'planner_id',
        type: 'business',
        subtype: 'planner-selector',
        rules: [{
          required: true,
          message: '',
          validator: function validator(rule, value, callback) {
            if (_this2.formValue.skip_plan === 2 && (value === null || value === undefined || value === '')) {
              callback(new Error('指定策划师'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        params: {
          options: [],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '需要策划跟进否',
        prop: 'skip_plan',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '是否需要策划跟进',
          trigger: 'change'
        }],
        params: {
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '指派设计师',
        prop: 'designer_id',
        type: 'business',
        subtype: 'designer-selector',
        rules: [{
          required: true,
          message: '请指派设计',
          trigger: 'change'
        }],
        params: {
          options: [],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '分配研发',
        prop: 'developer_id',
        type: 'business',
        subtype: 'developer-selector',
        rules: [{
          required: true,
          trigger: 'change',
          validator: function validator(rule, value, callback) {
            if (_this2.formValue.no_dev === 2 && (value === null || value === undefined || value === '')) {
              callback(new Error('请分配研发'));
            } else {
              callback();
            }
          }
        }],
        params: {
          options: [],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '是否需要研发',
        prop: 'no_dev',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '请选择是否需要研发介入',
          trigger: 'change'
        }],
        params: {
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '驳回原因',
        prop: 'reject_reason',
        type: 'input',
        subtype: 'textarea',
        rules: [{
          required: true,
          message: '驳回理由不能为空',
          trigger: 'change'
        }],
        params: {
          disabled: false
        }
      }, {
        label: '工时消耗（day）',
        prop: 'work_days',
        type: 'input',
        subtype: 'number',
        visible: this.batchList[0].type === '交互素材',
        rules: [{ validator: validateWorkDays, trigger: 'blur' }, {
          required: true,
          message: '请填写工时消耗',
          trigger: 'blur'
        }],
        params: {
          class: 'input-work_days',
          clearable: true,
          placeholder: '请填写工时消耗'
        }
      }, {
        label: '工时消耗（h）',
        prop: 'work_hours',
        type: 'input',
        subtype: 'number',
        visible: this.batchList[0].type === '非交互素材',
        rules: [{ validator: validateWorkHours, trigger: 'blur' }, {
          required: true,
          message: '请填写工时消耗，0.5的倍数',
          trigger: 'blur'
        }],
        params: {
          clearable: true,
          class: 'input-work_hours',
          step: 0.5,
          placeholder: '请填写工时消耗，0.5的倍数'
        }
      }, {
        label: '计划完成日期',
        prop: 'estimated_time',
        type: 'date-picker',
        subtype: 'date',
        rules: [{
          required: true,
          message: '请填写计划完成日期',
          trigger: 'change'
        }],
        params: {
          clearable: true,
          pickerOptions: {},
          placeholder: '选择日期'
        }
      }];

      var isInteractiveMaterial = this.batchList[0].type === '交互素材';
      var designerFormItem = {
        // 批量分配
        createInteractive: formItemList.filter(function (item) {
          return ['difficulty', 'planner_id', 'designer_id', 'work_days', 'estimated_time', 'skip_plan', 'no_dev', 'developer_id'].some(function (j) {
            return j === item.prop;
          });
        }),
        // 调整设计
        interactive: formItemList.filter(function (item) {
          return ['difficulty', 'planner_id', 'designer_id', 'work_days', 'estimated_time', 'skip_plan'].some(function (j) {
            return j === item.prop;
          });
        }),
        noninteractive: formItemList.filter(function (item) {
          return ['difficulty', 'work_hours', 'designer_id', 'estimated_time'].some(function (j) {
            return j === item.prop;
          });
        })
        // 根据 index 的值决定批量调整功能，
        // 如 0 批量分配人员；1 批量调整设计；2 批量撤回分配；3 设计批量撤回；4 批量调整研发
        // index 的值 = 按钮的位置排序
      };var formItemUtils = [
      // 批量分配人员
      isInteractiveMaterial ? designerFormItem.createInteractive : designerFormItem.noninteractive,
      // 批量调整设计
      isInteractiveMaterial ? designerFormItem.interactive : designerFormItem.noninteractive, [], formItemList.filter(function (item) {
        return item.prop === 'reject_reason';
      }),
      // formItemList.filter((item) => item.prop === 'reject_reason'),
      // formItemList.filter((item) => item.prop === 'developer_id'),
      formItemList.filter(function (item) {
        return item.prop === 'developer_id';
      })];

      return formItemUtils[index] || [];
    },
    submit: function submit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var id, innerFormValue, isInteractiveCreation, designer, utils;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                id = _this3.formValue.id;
                innerFormValue = _extends({}, _this3.formValue, {
                  developer_id: Number(_this3.formValue.developer_id),
                  planner_id: Number(_this3.formValue.planner_id),
                  designer_id: Number(_this3.formValue.designer_id),
                  work_days: Number(_this3.formValue.work_days),
                  work_hours: Number(_this3.formValue.work_hours)
                });
                isInteractiveCreation = _this3.batchList[0].type === '交互素材';
                designer = {
                  createInteractive: ['difficulty', 'planner_id', 'designer_id', 'work_days', 'estimated_time', 'skip_plan', 'no_dev', 'developer_id'],
                  interactive: ['difficulty', 'planner_id', 'designer_id', 'work_days', 'estimated_time', 'skip_plan'],
                  noninteractive: ['difficulty', 'designer_id', 'work_hours', 'estimated_time']
                };
                utils = [_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var keyList;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          keyList = isInteractiveCreation ? designer.createInteractive : designer.noninteractive;
                          return _context2.abrupt('return', assignmentDemand(id, _.pick(innerFormValue, keyList)));

                        case 2:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this3);
                })), _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var keyList;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          keyList = isInteractiveCreation ? designer.interactive : designer.noninteractive;
                          return _context3.abrupt('return', assignmentDemand(id, _.pick(innerFormValue, keyList)));

                        case 2:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this3);
                })), _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          return _context4.abrupt('return', revocationDesigner(id));

                        case 1:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this3);
                })), _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          return _context5.abrupt('return', rejectDemand(id, {
                            reject_reason: innerFormValue.reject_reason
                          }));

                        case 1:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this3);
                })), _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          return _context6.abrupt('return', assignTaskToDeveloper({
                            id: id,
                            developer_id: innerFormValue.developer_id
                          }));

                        case 1:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this3);
                }))];

                if (!utils[_this3.dialogConfig.batchDialogType]) {
                  _context7.next = 19;
                  break;
                }

                _this3.loading = true;
                _context7.prev = 7;
                _context7.next = 10;
                return utils[_this3.dialogConfig.batchDialogType]();

              case 10:
                _this3.getDemandList();
                _this3.close();
                _context7.next = 18;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7['catch'](7);

                console.log(_context7.t0);
                _this3.loading = false;

              case 18:
                _this3.loading = false;

              case 19:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this3, [[7, 14]]);
      }))();
    },
    close: function close() {
      // eslint-disable-next-line vue/no-mutating-props
      this.dialogConfig.visible = false;
    }
  }
};